import { DataTableProps, ModalProps } from 'ts/interfaces/Components'
import ReceiptDataTable from './ReceiptDataTable'
import Modal from './Modal'

interface Props<T extends object> extends DataTableProps<T>, ModalProps {}

const CardTable = <T extends object>({
  dataKey,
  url,
  columns,
  config,
  listName,
  modalChild = null
}: Props<T>) =>{ 
  return (
  <>
    <ReceiptDataTable 
    columns={columns} 
    dataKey={dataKey} 
    url={url} 
    config={config} 
    listName={listName} />
    {modalChild ? <Modal>{modalChild}</Modal> : null}
  </>
)
}

export default CardTable
